import { AfterViewInit, Directive, ElementRef, Input, } from '@angular/core';

@Directive({
    standalone: false,
    selector: 'input[inputFocus]',
})
export class InputFocusDirective implements AfterViewInit {

    @Input('inputFocus')
    private focused: boolean;

    constructor(public element: ElementRef<HTMLElement>) {
    }

    ngAfterViewInit(): void {
        if (this.focused) {
            setTimeout(() => this.element.nativeElement.focus(), 0);
        }
    }
}